<template>
  <div class="Login pt-0">
    <v-row class="mainContent">
      <v-col
        class="contentLeft pa-sm-0"
        sm="6"
        cols="12"
      >
        <v-col
          offset-sm="2"
          offset="1"
          class="my-11"
          lg="8"
          sm="10"
          cols="10"
        >
          <div class="headerLogo">
            <v-img
              :src="imgsrc('logos', 'Amundi-Immo.svg')"
              class="logo-login"
              height="27"
              width="185"
            />
          </div>
          <h1 class="headerTitle my-6 my-lg-11">{{ $t('welcome.title') }}</h1>
          <div class="intro">
            <p>{{ $t('welcome.intro-1') }}</p>
            <p>{{ $t('welcome.intro-2') }}</p>
          </div>
          <div class="cgu mt-14 pa-8">
            <div class="title">
              {{ $t('welcome.cguTitle') }}
            </div>
            <div class="description mt-6">
              {{ $t('welcome.cguDescription') }}
            </div>
            <v-checkbox
              v-model="acceptCgu"
              :label="$t('welcome.cguCheckbox')"
              class="checkbox-dark cguCheckbox mt-7"
              elevation="0"
              color="#00D367"
              hide-details
            />
          </div>

          <div class="d-flex justify-end">
            <v-btn
              class="white--text loginSubmit"
              color="primary"
              elevation="1"
              @click="submit"
            >
              {{ $t('login.start') }}
              <v-icon
                right
                dark
              >
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>

          <div class="personalData mt-14">
            <div class="description mt-6">
              <v-expansion-panels
                v-model="expandedPanel"
                class="v-expansion-panels--custom v-expansion-panels--no-padding"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header class="d-flex v-expansion-panel-header--blue">
                    <div class="title flex-grow-1">
                      {{ $t('welcome.personalDataTitle') }}
                    </div>
                    <div class="expand-helper">
                      {{ expandHelper }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <section class="disclaimer-section">
                      <p class="disclaimer">
                        {{ $t('welcome.disclaimer.introduction') }}
                      </p>
                    </section>
                    <section class="disclaimer-section">
                      <p class="disclaimer disclaimer--subtitle">
                        {{ $t('welcome.disclaimer.subtitle-1') }}
                      </p>
                      <p class="disclaimer disclaimer--text-1">
                        {{ $t('welcome.disclaimer.text-1') }}
                      </p>
                    </section>
                    <section class="disclaimer-section">
                      <p class="disclaimer disclaimer--subtitle">
                        {{ $t('welcome.disclaimer.subtitle-2') }}
                      </p>
                      <p class="disclaimer disclaimer--text-2">
                        {{ $t('welcome.disclaimer.text-2') }}
                      </p>
                    </section>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <section class="disclaimer-section">
                <p class="disclaimer">
                  {{ $t('welcome.personalDataDescription') }}
                  <a :href="`mailto:${MAIL_TO}`">{{ MAIL_TO }}</a>.
                </p>
              </section>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          class="copyRight"
          align="center"
          justify="center"
        >
          <div>{{ $t('login.copy_right') }}</div>
          <v-img
            :src="imgsrc('icons', 'WeSave-Conseil-logo-watermark@3x.svg')"
            class="logo-login"
            height="13"
            width="48"
          />
        </v-col>
      </v-col>
      <v-col
        sm="6"
        class="contentRight pa-0 d-none d-sm-flex"
      >
        <v-img
          height="auto"
          width="100%"
          cover
          :src="imgsrc('backgrounds', 'welcome-image.jpg')"
          class="backgroundsLogin"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CommonMixin from '@/mixins/store/CommonMixin'
  import mixinDynImage from '@/mixins/utils/dynImage.js'
  import ApiService from '@/services/ApiService'
  import { PERSON_STATUS } from '@/services/models.const'

  const MAIL_TO = 'dpo@amundi.com'

  export default {
    mixins: [CommonMixin, mixinDynImage,],
    data() {
      return {
        expandedPanel: null,
        MAIL_TO,
        acceptCgu: false,
        sections: [
          {
            key: 1,
            title: this.$t('welcome.section1.title'),
          },
          {
            key: 2,
            title: this.$t('welcome.section2.title'),
          },
          {
            key: 3,
            title: this.$t('welcome.section3.title'),
          },
          {
            key: 4,
            title: this.$t('welcome.section4.title'),
          },
          {
            key: 5,
            title: this.$t('welcome.section5.title'),
          },
        ],
      }
    },
    computed: {
      expandHelper() {
        const key =
          this.expandedPanel === 0 ? 'welcome.disclaimer.helper.closed' : 'welcome.disclaimer.helper.opened'

        return this.$t(key)
      },
    },
    mounted() {
      this.acceptCgu = !!this.currentUser.user_consent
    },
    methods: {
      async submit() {
        this.$store.commit('profile/resetFormErrors')
        if (this.acceptCgu !== !!this.currentUser.user_consent) {
          const result = await ApiService.updatePerson(this.currentUserId, {
            type: 'people',
            attributes: {
              user_consent: this.acceptCgu,
            },
          })
          this.$store.commit('profile/updatePersonConsent', result)
        }
        if (this.currentUser.person_kind === 'indivisaire-sans-mandataire') {
          this.$store.commit('profile/selectProfile', this.currentUser.id)
          this.$store.commit('common/setConfigFields', 'indivisaire-sans-mandataire')
          if (
            [PERSON_STATUS.created, PERSON_STATUS.pending,].includes(this.currentUser.meta.customer_file_status)
          ) {
            this.$router.push({ name: 'Subscription', })
          } else {
            this.$router.push({ name: 'Profile', })
          }
        } else {
          this.$router.push({ name: 'Profile', })
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.Login {
  height: 100%;
  background-color: $color-ffffff;
  overflow: hidden;
  .mainContent {
    height: 100%;
    .contentLeft {
      position: relative;
      .headerTitle {
        letter-spacing: 0;
        font-size: 3.13rem;
        color: $color-000000;
        font-weight: bold;
        line-height: 1.4em;
        @media (max-width: 1025px) {
          font-size: 2rem;
        }
      }
      p {
        font-size: 1.4em;
        color: $color-4d4d4f;
      }
      .loginDescription {
        font-size: 1.4em;
        color: $color-4d4d4f;
        line-height: 1.6em;
        @media (max-width: 1025px) {
          font-size: 1rem;
        }
      }
      .description {
        margin-top: 1em;
        font-size: 1em;
        color: $color-9e9fa2;
        line-height: 1.6em;
        text-align: justify;
        @media (max-width: 1025px) {
          font-size: 0.8rem;
        }
      }
      .stepper-sections {
        .sectionStep {
          color: $color-009ee0;
          text-transform: uppercase;
          font-size: 0.8em;
          font-weight: 600;
          letter-spacing: 0.32px;
          line-height: 20px;
        }
        .sectionTitle {
          color: $color-000000;
          font-size: 1.3em;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 2em;
        }
        .stepperLine {
          height: 45px;
          width: 2px;
          border-radius: 1px;
          background-color: $color-009ee0;
          border: 2px solid $color-009ee0;
        }
        .setpperCircle {
          height: 27px;
          width: 27px;
          border: 7px solid $color-009ee0;
          border-radius: 15px;
        }
      }

      .personalData {
        .title {
          color: $color-000000;
          font-size: 1em !important;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 2em;
        }
        .description {
          color: $color-4d4d4f;
          font-size: 0.9em;
          letter-spacing: 0.21px;
          line-height: 1.4em;
        }
        .expand-helper {
          font-size: 14px;
          color: $color-009ee0;
          text-align: right;
        }
      }
      /* stylelint-disable max-nesting-depth */
      .cgu {
        box-sizing: border-box;
        border: 1.4px solid rgba(121, 137, 183, 0.08);
        border-radius: 4px;
        background-color: $color-fafbff;
        .title {
          font-weight: 600;
          font-size: 1.3em;
          color: $color-202122;
          @media (max-width: 1025px) {
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: 0;
          }
        }
        .description {
          color: $color-4d4d4f;
          font-size: 0.9em;
          font-weight: 500;
          letter-spacing: 0.21px;
          line-height: 1.4em;
        }
        .cguCheckbox {
          color: $color-000000 !important;
          font-size: 1.2em;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 2em;
        }
        .checkbox-dark {
          opacity: 0.4;

          label {
            color: $color-009ee0 !important;
            font-size: 16px;
            letter-spacing: 0.24px;
            line-height: 24px;
            margin-left: 1rem;
          }

          &.v-input--is-label-active {
            opacity: 1;
          }
        }
        .subDescription {
          color: $color-9e9fa2;
          font-size: 0.88em;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 1.2em;
        }
      }
      .copyRight {
        div {
          color: $color-b4bad2;
          font-size: 0.8em;
          font-weight: 500;
          letter-spacing: 0.18px;
          line-height: 1em;
          text-align: center;
        }
      }
      .loginSubmit {
        height: 48px;
        width: 165px;
        font-size: 1em;
        text-transform: inherit;
        box-shadow: 0 4px 8px 0 rgba(31, 54, 139, 0.08) !important;
        border-radius: 8px;
        margin-top: 2.5em;
        @media (max-width: 1025px) {
          margin-top: 1.5em;
        }
      }
      .disclaimer-section {
        margin-bottom: 2rem;
      }

      .disclaimer {
        margin: 0;
        font-size: 0.9em;

        &--subtitle {
          font-weight: bold;
        }
      }
    }
    .contentRight {
      background-color: $color-ffffff;
      height: auto;
    }
  }
}
</style>
